module.exports = __webpack_public_path__ + "teqbahn-assets/media/7.464c431f.jpg";